import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { pageColors } from "../../mock";
import { useCart } from "../../context/CartContext";
import { ArrowLeft, ShoppingBag, Check, ExternalLink } from "lucide-react";

const SIZES = ["S", "M", "L", "XL"];
const PRICE = 12;

const SwampboySoap = () => {
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [size, setSize] = useState("M");
  const [added, setAdded] = useState(false);

  useEffect(() => { document.title = "TMM|SWAMPBOY SOAP"; }, []);

  const preorder = () => {
    addItem({
      id: `sbs-tee-${size.toLowerCase()}`,
      name: `Swampboy Soap Tee — size ${size}`,
      price: PRICE,
      image: "/img/sbs_front.webp",
      description: "Swampboy Soap white tee.",
      tag: "swampboy",
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };

  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <div className="brand-page">
        <button className="feed-back" onClick={() => navigate("/fashion")} data-testid="sbs-back">
          <ArrowLeft size={16} /> Back to Fashion
        </button>

        <header className="brand-hero-center" data-testid="sbs-hero">
          <img src="/img/swampclay.png" alt="Swampboy Soap" className="brand-hero-mark sbs" />
        </header>

        <section className="brand-preorder-preview" data-testid="sbs-preview">
          <div className="brand-preorder-tile">
            <img src="/img/sbs_front.webp" alt="Swampboy Soap tee — front" data-testid="sbs-front-image" />
          </div>
          <div className="brand-preorder-tile">
            <img src="/img/sbs_back.webp" alt="Swampboy Soap tee — back" data-testid="sbs-back-image" />
          </div>
        </section>

        <section className="brand-preorder-panel" data-testid="sbs-preorder-panel">
          <div className="brand-preorder-name">Swampboy Soap Tee</div>
          <div className="brand-preorder-price" data-testid="sbs-price">${PRICE}</div>

          <div className="brand-size-block">
            <div className="brand-size-label">Size</div>
            <div className="brand-size-row" role="radiogroup" aria-label="Select size">
              {SIZES.map((s) => (
                <button
                  key={s}
                  type="button"
                  role="radio"
                  aria-checked={size === s}
                  className={`brand-size-chip${size === s ? " active" : ""}`}
                  onClick={() => setSize(s)}
                  data-testid={`sbs-size-${s}`}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          <button
            type="button"
            className="btn-solid btn-huge"
            onClick={preorder}
            data-testid="sbs-preorder-btn"
          >
            {added ? (
              <>
                <Check size={18} /> Added — size {size}
              </>
            ) : (
              <>
                <ShoppingBag size={18} /> Add to cart — size {size}
              </>
            )}
          </button>

          <a
            href="https://swampboysoap-shop-com-shop.fourthwall.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost sbs-more-btn"
            data-testid="sbs-more-link"
          >
            <ExternalLink size={16} /> More for Swamp
          </a>
        </section>
      </div>
    </>
  );
};

export default SwampboySoap;
